import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { RumSettings } from '../Models/ApplicationModels';

@Injectable({
  providedIn: 'root'
})
export class DatadogService {

  companyApiUrl: string = environment.companyApiBaseUrl;
  constructor(private http: HttpClient) { }
  getDatadogConfig(companyId: number) {
    const url = `${this.companyApiUrl}/GlobalSettings?CompanyId=${companyId}`;
    return this.http.get<RumSettings>(url); 
  }
}
